/**
 * Handles tabbedContent toggle (Avoids toggle effect to support future new tabs)
 * @returns null or creates class
 */

function doTabbedContent() {
  if (customElements.get("tabbed-content")) return null;

  class TabbedContent extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll(".tab-trigger");
      this.tabBodies = this.querySelectorAll(".body-tab");

      if (this.tabs == null || this.tabBodies == null) {
        console.error(`doTabbedContent, a variable is null`);
      }
      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        const tabNumber = tab.dataset.tab;
        const bodyToShow = this.querySelector(
          `.body-tab[data-tab="${tabNumber}"]`
        );

        tab.addEventListener("click", (e) => {
          e.preventDefault();

          this.hideAllBodyTabs();
          this.deactivateAllTabTriggers();
          bodyToShow.setAttribute("data-status", 1);
          tab.setAttribute("data-status", 1);
        });
      });
      this.open2ndTabByUrl()
    }

    hideAllBodyTabs() {
      this.tabBodies.forEach((bodyTab) => {
        bodyTab.setAttribute("data-status", 0);
      });
    }

    deactivateAllTabTriggers() {
      this.tabs.forEach((tab) => tab.setAttribute("data-status", 0));
    }

    open2ndTabByUrl() {
      const url = window.location.search;
      const params = new URLSearchParams(url);
      const urlQuery = params.get("tabbedContent");
      if (urlQuery == null || urlQuery !== "2") return null;

      const bodyToShow = this.querySelector(
        `.body-tab[data-tab="2"]`
      );

      this.hideAllBodyTabs();
      this.deactivateAllTabTriggers();
      bodyToShow.setAttribute("data-status", 1);
      this.tabs[1].setAttribute("data-status", 1);

    }
  }

  customElements.define("tabbed-content", TabbedContent);
}

doTabbedContent();
